module.exports = __webpack_public_path__ + "img/sv.2e44b8d3.svg";